import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TrustedDestinationsState } from './trusted-destinations.reducer';

export const selectTrustedDestinationsState =
  createFeatureSelector<TrustedDestinationsState>('trustedDestinations');

export const selectTrustedDestinations = createSelector(
  selectTrustedDestinationsState,
  (state) => state.items
);

export const selectTrustedDestinationsMeta = createSelector(
  selectTrustedDestinationsState,
  (state) => state.meta
);

export const selectSelectedTrustedDestination = createSelector(
  selectTrustedDestinationsState,
  (state) => state.selectedItem
);

export const selectTrustedDestinationsLoading = createSelector(
  selectTrustedDestinationsState,
  (state) => state.isLoading
);

export const selectTrustedDestinationLoading = createSelector(
  selectTrustedDestinationsState,
  (state) => state.isLoadingItem
);

export const selectTrustedDestinationsSubmitting = createSelector(
  selectTrustedDestinationsState,
  (state) => state.isSubmitting
);

export const selectTrustedDestinationsDeleting = createSelector(
  selectTrustedDestinationsState,
  (state) => state.isDeleting
);

export const selectTrustedDestinationsExporting = createSelector(
  selectTrustedDestinationsState,
  (state) => state.isExporting
);

export const selectTrustedDestinationsError = createSelector(
  selectTrustedDestinationsState,
  (state) => state.error
);

export const selectTrustedDestinationsLastQuery = createSelector(
  selectTrustedDestinationsState,
  (state) => state.lastQuery
);
